export const On = 'on'
export const Off = 'off'
export const processing = 'processing'

export const RobinsonError = {
    slug: 'robinson_error',
    message: 'The entity has been blocked by the robinson process which ended unexpectedly in an error'
}

export const EobinsonWorking = {
    slug: 'robinson_working',
    message: 'The entity has been blocked by the robinson process and is still processing it. Wait some minutes'
}

export const RobinsonFound = {
    slug: 'robinson_found',
    message: 'The contact has been deactivated because it was found on the Robinson exclusion list'
}

export const EditedByCsv = {
    slug: 'edited_by_csv',
    message: 'El contacto ha sido modificado tras la importación de un CSV'
}

export const EditedByApi = {
    slug: 'edited_by_api',
    'message': 'El contacto ha sido modificado desde la API'
}

export const EditedByForm = {
    slug: 'edited_by_form',
    message: 'El contacto ha sido modificado desde la aplicación'
}

export const ImportedFromApi = {
    slug: 'imported_from_api',
    'message': 'El contacto ha sido importado a través de la API'
}

export const ImportedFromCsv = {
    slug: 'imported_from_csv',
    message: 'El contacto ha sido importado desde un fichero Csv'
}

export const CreatedWithForm = {
    slug: 'created_with_form',
    message: 'El contacto ha sido creado mediante el formulario de altas'
}

export const CampaignIncluded = {
    slug: 'campaign',
    message: 'El contacto ha sido includo en una campaña'
}

export const RemovedByTradeMark = {
    slug: 'trademark_remove',
    message: 'La empresa a la que pertenece el contacto nos pide eliminarlo'
}

export const HasBeenUnsubscribed = {
    slug: 'unsubscribe',
    message: 'El contacto se dio de baja tras una determinada campaña'
}
